(() => {
  const initialise = root => {
    if (root.dataset.helpReady) return;
    const tabs = [...root.querySelectorAll('[data-game-tab]')];
    const panels = [...root.querySelectorAll('[data-game-panel]')];
    if (!tabs.length || !panels.length) return;
    root.dataset.helpReady = 'true';
    const tablist = root.querySelector('[data-game-tabs]');
    const aliases = new Map();
    const buttons = [...root.querySelectorAll('[data-play-video]')];
    const decode = value => { try { return decodeURIComponent(value); } catch { return value; } };
    panels.forEach(panel => {
      aliases.set(panel.id, panel.id);
      (panel.dataset.legacyAnchors || '').split('|').filter(Boolean).forEach(alias => aliases.set(alias, panel.id));
    });
    const closePlayer = (panel, focus) => {
      const frame = panel.querySelector('[data-help-frame]');
      if (!frame) return;
      frame.remove();
      const button = panel.querySelector('[data-play-video]');
      if (button) { button.hidden = false; if (focus) button.focus(); }
      const close = panel.querySelector('[data-close-video]');
      if (close) close.hidden = true;
    };
    const choose = (id, options = {}) => {
      const selected = panels.find(panel => panel.id === id);
      if (!selected) return;
      panels.forEach(panel => {
        panel.hidden = panel !== selected;
        if (panel !== selected) closePlayer(panel, false);
      });
      tabs.forEach(tab => {
        const active = tab.dataset.gameTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      if (options.history && location.hash !== '#' + id) history.pushState(null, '', '#' + id);
      if (options.scroll) selected.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    };
    tablist.setAttribute('role', 'tablist');
    tabs.forEach(tab => { tab.setAttribute('role','tab'); tab.setAttribute('aria-controls',tab.dataset.gameTab); });
    panels.forEach(panel => {
      panel.setAttribute('role','tabpanel');
      const tab = tabs.find(item => item.dataset.gameTab === panel.id);
      if (tab) panel.setAttribute('aria-labelledby',tab.id);
      panel.tabIndex = 0;
    });
    buttons.forEach(button => {
      const type = button.dataset.videoType;
      const id = button.dataset.videoId || '';
      if (!(type === 'youtube' && /^[\w-]{11}$/.test(id)) && !(type === 'vimeo' && /^\d+$/.test(id))) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        panels.forEach(panel => closePlayer(panel, false));
        const panel = button.closest('[data-game-panel]');
        const iframe = document.createElement('iframe');
        iframe.dataset.helpFrame = 'true';
        iframe.title = button.dataset.videoTitle;
        iframe.src = type === 'youtube' ? 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0' : 'https://player.vimeo.com/video/' + id + '?autoplay=1&playsinline=1';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.setAttribute('allowfullscreen','');
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        button.hidden = true;
        panel.querySelector('[data-player]').append(iframe);
        panel.querySelector('[data-close-video]').hidden = false;
        iframe.focus();
      });
    });
    root.querySelectorAll('[data-close-video]').forEach(button => button.addEventListener('click', () => closePlayer(button.closest('[data-game-panel]'),true)));
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const id = aliases.get(decode(link.getAttribute('href').slice(1)));
      if (!id) return;
      event.preventDefault();
      choose(id, {history:true,scroll:true});
    });
    tablist.addEventListener('keydown', event => {
      const tab = event.target.closest('[data-game-tab]');
      if (!tab) return;
      const index = tabs.indexOf(tab);
      let next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      choose(tabs[next].dataset.gameTab,{history:true});
      tabs[next].focus();
    });
    const hashChanged = () => {
      const id = aliases.get(decode(location.hash.slice(1)));
      if (id) choose(id,{scroll:true});
    };
    window.addEventListener('hashchange',hashChanged);
    window.addEventListener('popstate',hashChanged);
    const initial = aliases.get(decode(location.hash.slice(1)));
    choose(initial || panels[0].id);
    if (initial) requestAnimationFrame(() => choose(initial,{scroll:true}));
    if (window.Shopify && window.Shopify.designMode) {
      root.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-game-panel]');
        if (panel) choose(panel.id,{scroll:true});
      });
    }
  };
  const initialiseAll = () => document.querySelectorAll('[data-fp-help]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialiseAll,{once:true});
  else initialiseAll();
  document.addEventListener('shopify:section:load',initialiseAll);
})();
